import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { JobsScreen } from './JobsScreen';
import type { JobsSearch } from './jobs-search';

const route = getRouteApi('/jobs');

export function JobsRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onSearchChange = useCallback(
    (next: JobsSearch) => {
      void navigate({
        replace: true,
        search: () => ({
          queue: next.queue,
          state: next.state,
          // Absent at the first page, so the common link is the short one.
          ...(next.offset === 0 ? {} : { offset: next.offset }),
          ...(next.job === undefined ? {} : { job: next.job }),
        }),
      });
    },
    [navigate],
  );

  return <JobsScreen search={search} onSearchChange={onSearchChange} />;
}
